import React from "react";
import ReactLoader from "react-loader";
import { connect } from "react-redux";
import { isLoaded } from "../redux/selectors/isLoaded";
import "./Loader.module.css";

function Loader({ isLoaded }) {
  return <ReactLoader loaded={isLoaded} />;
}

export default connect(state => ({ isLoaded: isLoaded(state) }))(Loader);
